import { render } from "./FilterModal.vue?vue&type=template&id=b34720be"
import script from "./FilterModal.vue?vue&type=script&lang=js"
export * from "./FilterModal.vue?vue&type=script&lang=js"

import "./FilterModal.vue?vue&type=style&index=0&id=b34720be&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__